import {observer} from 'mobx-react';
import React from 'react';
import {X2AgeCategoryStore} from '../X2AgeCategoryStore';

@observer
export class EditLevelForm extends React.Component<{ store: X2AgeCategoryStore }> {
  render() {
    const {store} = this.props;

    if (store.editLevel === null)
      return null;

    const name = store.editLevel.name;
    return (
      <div className="row">
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
